import { render } from "./productOverviewItemCard.vue?vue&type=template&id=604643c6&scoped=true&ts=true"
import script from "./productOverviewItemCard.vue?vue&type=script&lang=ts"
export * from "./productOverviewItemCard.vue?vue&type=script&lang=ts"

import "./productOverviewItemCard.vue?vue&type=style&index=0&id=604643c6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604643c6"]])

export default __exports__